
import React from "react";
import { FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import { OfferFormValues } from "../../../schemas/offerFormSchema";
import { SortableOption } from "@/types/fieldsOptions";
import { isAvailabilityStatus, isSignupStatus } from "@/functions-shared/offer/offerStatusEnums";

interface StatusSectionProps {
  form: UseFormReturn<OfferFormValues>;
  availabilityStatusOptions: SortableOption[];
  signupStatusOptions: SortableOption[];
  markFieldAsModified?: (fieldName: string) => void;
}

export const StatusSection: React.FC<StatusSectionProps> = ({
  form,
  availabilityStatusOptions,
  signupStatusOptions,
  markFieldAsModified = () => {}
}) => {
  // Filter out any options with empty IDs to prevent Select.Item errors
  const filteredSignupOptions = signupStatusOptions.filter(opt => isSignupStatus(opt.id));
  const filteredAvailabilityOptions = availabilityStatusOptions.filter(opt => isAvailabilityStatus(opt.id));
  
  return (
    <div className="space-y-4">
      <FormField 
        control={form.control} 
        name="signupStatus" 
        render={({ field }) => (
          <FormItem>
            <FormLabel>Registration status</FormLabel>
            <Select 
              value={field.value} 
              onValueChange={value => {
                field.onChange(value);
                markFieldAsModified("signupStatus");
              }}
            >
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {filteredSignupOptions.length > 0 ? (
                  filteredSignupOptions.map(option => (
                    <SelectItem key={option.id} value={option.id}>
                      {option.label}
                    </SelectItem>
                  ))
                ) : (
                  <SelectItem value="default">Not specified</SelectItem>
                )}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )} 
      />
      
      <FormField 
        control={form.control} 
        name="availabilityStatus" 
        render={({ field }) => (
          <FormItem>
            <FormLabel>Availability status</FormLabel>
            <Select 
              value={field.value} 
              onValueChange={value => {
                field.onChange(value);
                markFieldAsModified("availabilityStatus");
              }}
            >
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {filteredAvailabilityOptions.length > 0 ? (
                  filteredAvailabilityOptions.map(option => (
                    <SelectItem key={option.id} value={option.id}>
                      {option.label}
                    </SelectItem>
                  ))
                ) : (
                  <SelectItem value="default">Not specified</SelectItem>
                )}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )} 
      />
    </div>
  );
};
